<template>
    <div class="box is-condensed category-box">
        <div class="category-header">
            <div class="has-text-centered">
                <p>#{{ index + 1 }}</p>
                <p style="font-size: 0.7rem">ID: {{ category.parameterId }}</p>
            </div>
            <div class="is-flex-grow-1 has-text-centered">
                <a :href="categoryUrl" @click.prevent="handleOpenCategory">
                    {{ category.categoryName }}
                </a>
            </div>
            <div class="category-options">
                <DropdownButton>
                    <template v-slot:trigger>
                        <button class="button is-small">
                            <span>{{ translate("common.options") }}</span>
                            <span class="icon">
                                <i class="fa fa-caret-down"></i>
                            </span>
                        </button>
                    </template>
                    <template v-slot:content>
                        <a class="dropdown-item" @click="handleDivideCategory">
                            <span class="icon">
                                <i class="fa fa-divide" />
                            </span>
                            <span>{{ translate("admin_categories.divide_category") }}</span>
                        </a>
                    </template>
                </DropdownButton>
            </div>
        </div>
        <div class="category-stats">
            <div class="category-stat">
                <span class="is-description">{{ translate("common.total_competitors") }}: </span>
                <span v-if="category.totalCompetitors > 0" class="tag is-white">
                    {{ category.totalCompetitors }}
                </span>
                <span v-else class="tag is-dark">
                    {{ category.totalCompetitors }}
                </span>
            </div>
            <div class="category-stat">
                <span class="is-description">{{ translate("admin_categories.competitor_candidates") }}: </span>
                <span class="tag is-info">
                    {{ category.totalCompetitorsForStatuses[COMPETITOR_CANDIDATE_STATUS] || 0 }}
                </span>
            </div>
            <div class="category-stat">
                <span class="is-description">{{ translate("admin_categories.payment_disqualifications") }}: </span>
                <span class="tag is-danger">
                    {{ category.totalCompetitorsForStatuses[COMPETITOR_PAYMENT_DQ_STATUS] || 0 }}
                </span>
            </div>
            <div class="category-stat">
                <span class="is-description">{{ translate("admin_categories.disqualified_at_verification") }}: </span>
                <span class="tag is-warning">
                    {{ category.totalCompetitorsForStatuses[COMPETITOR_FAILED_VERIFICATION_STATUS] || 0 }}
                </span>
            </div>
            <div class="category-stat">
                <span class="is-description">{{ translate("admin_categories.competitor_verified") }}: </span>
                <span class="tag is-success">
                    {{ category.totalCompetitorsForStatuses[COMPETITOR_VERIFIED_STATUS] || 0 }}
                </span>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { computed } from "vue";
    import DropdownButton from "../Common/DropdownButton.vue";
    import { translate } from "../Common/translations";
    import { CategorySummary } from "../Api/Categories/categoriesSummary";
    import {
        COMPETITOR_CANDIDATE_STATUS,
        COMPETITOR_FAILED_VERIFICATION_STATUS,
        COMPETITOR_PAYMENT_DQ_STATUS,
        COMPETITOR_VERIFIED_STATUS,
    } from "../Common/Competitors/types";

    const props = defineProps<{
        category: CategorySummary;
        index: number;
        eventId: number;
    }>();

    const emit = defineEmits<{
        divideCategory: [parameterId: number, categoryName: string];
        openCategory: [parameterId: number];
    }>();

    const categoryUrl = computed(() => {
        return `/${window.panelLocale}/pages/admin/events/${props.eventId}/competitors?parameterId=${props.category.parameterId}`;
    });

    const handleDivideCategory = () => {
        emit("divideCategory", props.category.parameterId, props.category.categoryName);
    };

    const handleOpenCategory = () => {
        emit("openCategory", props.category.parameterId);
    };
</script>
